import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import moment from 'moment'

import Login from './views/Login'
import AuthCallback from './views/AuthCallback'
import Dashboard from './views/Dashboard'
import StandardPhrases from './views/templates/StandardPhrases'

import ReportIndex from './views/reports/ReportIndex'
import ReportEdit from './views/reports/ReportEdit'
import ReportHome from './components/reports/ReportHome'
import ReportSection from './components/reports/ReportSection'

import ReportTypes from './views/templates/ReportTypes'
import FieldIndex from './views/templates/reportfields/FieldIndex'
import FieldEdit from './views/templates/reportfields/FieldEdit'
import SectionIndex from './views/templates/reportsections/SectionIndex'
import SectionEdit from './views/templates/reportsections/SectionEdit'

import VendorChecklist from './views/VendorChecklist'

import { RouteNames } from './utils/constants'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { 
        allowAnonymous: true
      }
    },
    {
      path: '/authcallback',
      name: 'auth-callback',
      component: AuthCallback,      
      meta: { 
        allowAnonymous: true
      }
    },
    {
      path: '/reports',
      alias: '/',      
      name: RouteNames.Reports.ReportIndex,
      component: ReportIndex
    },
    {
      path: '/reports/edit/:jobReference',
      name: RouteNames.Reports.ReportEdit,
      component: ReportEdit,
      props: true,
      children: [
        {
          name: RouteNames.Reports.ReportEditHome,
          path: 'home',
          component: ReportHome,
          props: true
        },
        {
          name: RouteNames.Reports.ReportEditSection,
          path: 'section/:sectionNumber',
          component: ReportSection,
          props: true
        }
      ]
    },
    {
      path: '/templates/standardphrases',
      name: 'standard-phrase-index',
      component: StandardPhrases
    },
    {
      path: '/templates/reporttypes',
      name: 'report-type-templates',
      component: ReportTypes
    },
    {
      path: '/templates/sections',
      name: 'report-section-template-index',
      component: SectionIndex
    },
    {
      path: '/templates/sections/:sectionId',
      name: 'report-section-template-edit',
      component: SectionEdit,
      props: true
    },
    {
      path: '/templates/fields',
      name: RouteNames.Templates.FieldTemplateIndex,
      component: FieldIndex
    },
    {
      path: '/templates/fields/:fieldId',
      name: RouteNames.Templates.FieldTemplateEdit,
      component: FieldEdit,
      props: true
    },
    {
      path: '/vendorchecklist',
      name: 'vendor-checklist',
      component: VendorChecklist
    }
  ]
})

router.beforeEach((to, from, next) => {
  let token = store.state.accessToken
  let expiresAt = store.state.accessTokenExpiresAt
  let tokenExpired = moment(expiresAt).isBefore(moment().subtract(3600, 'second'))
  let isLoggedIn = token && !tokenExpired
  
  if (to.name == 'login' && isLoggedIn) {
    next({ path: from.path })
  }
  else if (to.meta.allowAnonymous || isLoggedIn) {
    next()
  }
  else {
    next({ path: '/login', query: { redirect: to.fullPath } })
  }
})

export default router